import React from "react";
import Avatar from "../Avatar";
import styled from "styled-components";
import { convertTimeIntoHourMin } from "../utils/generic";

const ContactMessageUI = styled.div`
  min-width: 250px;
  .contact-name {
    // font-family: Plus Jakarta Sans;
    font-size: 20px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.05em;
    text-align: left;
    color: #000000;
    margin-right: auto;
  }
  .contact-line {
    margin: 10px -18px;
  }
  .contact-number {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.05em;
    text-align: left;
    color: #b1b1b1;
	// margin-left: 42px;


    &:hover {
      color: #23527c;
    }
  }
`;

export default function Contact({ message }) {
  return (
    <ContactMessageUI>
      <div className="d-flex align-items-center pt-2 pb-2">
        <span
          class="material-symbols-outlined mr-4"
          style={{ fontSize: "34px", color: "#28A6DE" }}
        >
          account_circle
        </span>
        <div className="contact-name">
          {(message &&
            message.content &&
            message.content.contact &&
            message.content.contact[0].name &&
            message.content.contact[0].name.formatted_name) ||
            "Contact"}
        </div>
        {/* <span
          class="material-symbols-outlined"
          style={{ color: "#B1B1B1", fontSize: "18px" }}
        >
          chevron_right
        </span> */}
      </div>
      <hr className="contact-line" />
      <div className="text-center pt-2">
        <a
          className="contact-number"
          target="_blank"
          href={`tel:${message &&
            message.content &&
            message.content.contact &&
            message.content.contact[0].phones &&
            message.content.contact[0].phones[0] &&
            message.content.contact[0].phones[0].phone}`}
        >
          {message &&
            message.content &&
            message.content.contact &&
            message.content.contact[0].phones &&
            message.content.contact[0].phones[0] &&
            message.content.contact[0].phones[0].phone}
        </a>
      </div>
      {/* <div className="message-info-td">
        <span className="message-time">{convertTimeIntoHourMin(message.timeStamp)}</span>
        <span className="material-symbols-outlined message-deliver">done_all</span>
      </div> */}
    </ContactMessageUI>
  );
}



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/Message Components/Contact.jsx